"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(require("./Input"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Input/index.js
 ** module id = 161
 ** module chunks = 0
 **/